import { motion } from 'framer-motion'
import { RefreshCw } from 'lucide-react'
import { Button } from './Button'

// Full-screen blocking reload prompt. No dismiss — the user must reload.
// Shared by the stale-data prompt (AppShell) and the new-version prompt (App).
export function ReloadPrompt({ title, message, buttonLabel = 'Reload now' }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className="fixed inset-0 z-[700] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(12px)', WebkitBackdropFilter: 'blur(12px)' }}
    >
      <motion.div
        initial={{ scale: 0.92, opacity: 0, y: 16 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.96, opacity: 0, y: 8 }}
        transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1], delay: 0.05 }}
        className="flex flex-col items-center gap-6 w-full max-w-sm text-center px-8 py-10 bg-surface border border-border rounded-2xl shadow-2xl shadow-black/40"
      >
        <div className="flex items-center justify-center w-16 h-16 rounded-2xl bg-surface-raised border border-border">
          <RefreshCw size={30} className="text-accent" />
        </div>

        <div className="flex flex-col gap-2">
          <p className="text-xl font-bold text-text" style={{ fontFamily: 'Helvetica Neue, sans-serif', letterSpacing: '-0.02em' }}>
            {title}
          </p>
          <p className="text-sm text-text-muted" style={{ fontFamily: 'DM Sans, sans-serif' }}>
            {message}
          </p>
        </div>

        <Button variant="primary" size="2xl" onClick={() => window.location.reload()} className="w-full">
          <RefreshCw size={18} />
          {buttonLabel}
        </Button>
      </motion.div>
    </motion.div>
  )
}
